import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { tokens, theme } from "../../theme";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import AnyBox3 from "../../components/3paramBox";
import AnyBox1 from "../../components/1paramBox";
import mqtt from "mqtt";

import pond1 from "../../api/pond1";
import pond2 from "../../api/pond2";
import pond3 from "../../api/pond3";
import pond4 from "../../api/pond4";
import pond5 from "../../api/pond5";
import AnyBox2 from "../../components/2paramBox";
import LineChart3Param from "../../components/3paramLinechart";
import LineChart2Param from "../../components/2paramLinechart";
import LineChart1Param from "../../components/1paramLinechart";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [mode, setMode] = useState("dark-gray");
  const [dataPayloads, setDataPayloads] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const [pond1Value, setPond1Value] = useState({
    temp: "0.0",
    pH: "0.0",
    DO: "0.0",
  });
  const [pond2Value, setPond2Value] = useState({
    temp: "0.0",
    pH: "0.0",
    DO: "0.0",
  });
  const [pond3Value, setPond3Value] = useState({
    temp: "0.0",
    pH: "0.0",
    DO: "0.0",
  });
  const [pond4Value, setPond4Value] = useState({
    cl: "0.0",
  });
  const [pond5Value, setPond5Value] = useState({
    temp: "0.0",
    pH: "0.0",
  });

  useEffect(() => {}, [mode, theme.palette.mode]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchFunctions = [pond1, pond2, pond3, pond4, pond5];
      const dataKeys = [
        "dataPayload1",
        "dataPayload2",
        "dataPayload3",
        "dataPayload4",
        "dataPayload5",
      ];

      try {
        const results = await Promise.all(
          fetchFunctions.map((fetchFunc) => fetchFunc())
        );
        const payloads = results.reduce((acc, result, index) => {
          if (result) {
            acc[dataKeys[index]] = result;
          } else {
            console.log(`No data received for ${dataKeys[index]}`);
          }
          return acc;
        }, {});
        setDataPayloads(payloads);

        // console.log(
        //   payloads.dataPayload1.temp[payloads.dataPayload1.temp.length - 1]
        //     .value
        // );

        // console.log(
        //   payloads.dataPayload5.temp[payloads.dataPayload1.temp.length - 1]
        //     .value
        // );

        if (payloads.dataPayload1) {
          const p1_len = payloads.dataPayload1.temp.length - 1;
          const p1 = payloads.dataPayload1;
          setPond1Value({
            temp: p1.temp[p1_len].value,
            pH: p1.pH_value[p1_len].value,
            DO: p1.DO_value[p1_len].value,
          });
        }

        if (payloads.dataPayload2) {
          const p2_len = payloads.dataPayload2.temp.length - 1;
          const p2 = payloads.dataPayload2;
          setPond2Value({
            temp: p2.temp[p2_len].value,
            pH: p2.pH_value[p2_len].value,
            DO: p2.DO_value[p2_len].value,
          });
        }

        if (payloads.dataPayload3) {
          const p3_len = payloads.dataPayload3.temp.length - 1;
          const p3 = payloads.dataPayload3;
          setPond3Value({
            temp: p3.temp[p3_len].value,
            pH: p3.pH_value[p3_len].value,
            DO: p3.DO_value[p3_len].value,
          });
        }

        if (payloads.dataPayload4) {
          const p4_len = payloads.dataPayload4.chlorine_value.length - 1;
          const p4 = payloads.dataPayload4;
          setPond4Value({
            cl: p4.chlorine_value[p4_len].value,
          });
        }

        if (payloads.dataPayload5) {
          const p5_len = payloads.dataPayload5.temp.length - 1;
          const p5 = payloads.dataPayload5;
          setPond5Value({
            temp: p5.temp[p5_len].value,
            pH: p5.pH_value[p5_len].value,
          });
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [pond1Value, pond2Value, pond3Value, pond4Value, pond5Value]);

  // console.log(dataPayloads.dataPayload4);

  useEffect(() => {
    const clientId = "mqttjs_" + Math.random().toString(16).substr(2, 8);
    const host = "wss://j0a11a91.ala.us-east-1.emqxsl.com:8084/mqtt";
    const options = {
      clientId,
      clean: true,
      connectTimeout: 4000,
      username: "droneai",
      password: "droneai888",
      reconnectPeriod: 1000,
      rejectUnauthorized: true,
    };
    // console.log("Connecting mqtt client");
    const client = mqtt.connect(host, options);
    client.on("error", (err) => {
      console.log("Connection error: ", err);
      client.end();
    });
    client.on("reconnect", () => {
      console.log("Reconnecting...");
    });
    client.on("connect", () => {
      // console.log("Client connected: ${clientId}");
      client.subscribe("devices/hatyai/1", { qos: 0 });
      client.subscribe("devices/hatyai/2", { qos: 0 });
      client.subscribe("devices/hatyai/3", { qos: 0 });
      client.subscribe("devices/hatyai/4", { qos: 0 });
      client.subscribe("devices/hatyai/5", { qos: 0 });
    });
    client.on("message", (topic, payload) => {
      try {
        const message = JSON.parse(payload.toString());
        const { temp, pH, DO, chlorine } = message;

        switch (topic) {
          case "devices/hatyai/1":
            setPond1Value({ temp, pH: pH.value, DO: DO.value });
            break;
          case "devices/hatyai/2":
            setPond2Value({ temp, pH: pH.value, DO: DO.value });
            break;
          case "devices/hatyai/3":
            setPond3Value({ temp, pH: pH.value, DO: DO.value });
            break;
          case "devices/hatyai/4":
            setPond4Value({ cl: chlorine.value });
            break;
          case "devices/hatyai/5":
            setPond5Value({ temp, pH: pH.value });
            break;
          default:
            console.log("Unknown topic: ", topic);
        }
      } catch (error) {
        console.error("Error parsing payload: ", error);
      }
      return () => {
        client.end();
      };
    });
  }, []);

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="DASHBOARD"
          subtitle="Water Quality Sensing and Treatment at Hatyai Hospital"
        />
        <Box>
          <Button
            sx={{
              backgroundColor: colors.greenAccent[400],
              color: colors.grey[600],
              padding: "10px 20px",
              marginLeft: "10px",
            }}
            onClick={() => window.location.reload()}
          >
            <RefreshIcon />
          </Button>
        </Box>
      </Box>
      {/* Content */}
      <Box>
        {/* <Towerlist /> */}

        <Grid container spacing={2}>
          <Grid item xs={12} md={2.35}>
            <Box
              // gridColumn="span 4"
              backgroundColor={colors.primary[400]}
              // minWidth={200}
              width={"100%"}
              height={"100%"}
              padding={"15px"}
            >
              <AnyBox3
                name="บ่อปรับสภาพ (1)"
                PH={pond1Value.pH}
                DO={pond1Value.DO}
                TEMP={pond1Value.temp}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={2.35}>
            <Box
              // gridColumn="span 4"
              backgroundColor={colors.primary[400]}
              // minWidth={200}
              width={"100%"}
              height={"100%"}
              padding={"15px"}
            >
              <AnyBox3
                name="บ่อเติมอากาศ (2)"
                PH={pond2Value.pH}
                DO={pond2Value.DO}
                TEMP={pond2Value.temp}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={2.35}>
            <Box
              backgroundColor={colors.primary[400]}
              width={"100%"}
              height={"100%"}
              padding={"15px"}
            >
              <AnyBox3
                name="บ่อตะกอน (3)"
                PH={pond3Value.pH}
                DO={pond3Value.DO}
                TEMP={pond3Value.temp}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={2.35}>
            <Box
              backgroundColor={colors.primary[400]}
              // minWidth={200}
              width={"100%"}
              height={"100%"}
              padding={"15px"}
            >
              <AnyBox1 name="บ่อคลอรีน (4)" CL={pond4Value.cl} />
            </Box>
          </Grid>
          <Grid item xs={12} md={2.35}>
            <Box
              // gridColumn="span 4"
              backgroundColor={colors.primary[400]}
              // minWidth={200}
              width={"100%"}
              height={"100%"}
              padding={"15px"}
            >
              <AnyBox2
                name="บ่อสูบน้ำเสีย (5)"
                PH={pond5Value.pH}
                TEMP={pond5Value.temp}
              />
            </Box>
          </Grid>

          {/* <Grid item xs={3} md={2.5}>
            <Box
              // gridColumn="span 4"
              backgroundColor={colors.primary[400]}
              // minWidth={200}
              height={"100%"}
            >
              <AnyBox3 name="บ่อปรับสภาพ (1)" PH="7.5" DO="1.2" TEMP="37.5" />
            </Box>
          </Grid> */}
        </Grid>

        {/* GRID & CHARTS */}
        <Box
          display="grid"
          gridTemplateColumns="repeat(20, 1fr)"
          gridAutoRows="250px"
          gap="20px"
        >
          {/* ROW 2 */}
          {/* First pond */}
          <Box
            mt="20px"
            gridColumn="span 10"
            gridRow="span 1"
            backgroundColor={colors.primary[400]}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex" sx={{ justifyContent: "space-between" }}>
                <Typography
                  variant="h4"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  บ่อปรับสภาพ
                </Typography>

                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color={colors.greenAccent[300]}
                >
                  (ปกติ)
                </Typography>
              </Box>
            </Box>
            <Box height="180px" m="-20px 0 0 0">
              {dataPayloads.dataPayload1 ? (
                <LineChart3Param
                  isDashboard={true}
                  dataPayload={dataPayloads.dataPayload1}
                />
              ) : (
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color={colors.grey[100]}
                  textAlign="center"
                  mt="80px"
                >
                  Loading...
                </Typography>
              )}
            </Box>
          </Box>
          {/* Second pond */}
          <Box
            mt="20px"
            gridColumn="span 10"
            gridRow="span 1"
            backgroundColor={colors.primary[400]}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" sx={{ justifyContent: "space-between" }}>
                  <Typography
                    variant="h4"
                    fontWeight="600"
                    color={colors.grey[100]}
                  >
                    บ่อเติมอากาศ
                  </Typography>

                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color={colors.greenAccent[300]}
                  >
                    (ปกติ)
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box height="180px" m="-20px 0 0 0">
              {dataPayloads.dataPayload1 ? (
                <LineChart3Param
                  isDashboard={true}
                  dataPayload={dataPayloads.dataPayload2}
                />
              ) : (
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color={colors.grey[100]}
                  textAlign="center"
                  mt="80px"
                >
                  Loading...
                </Typography>
              )}
            </Box>
          </Box>
          {/* Third pond */}
          <Box
            gridColumn="span 10"
            gridRow="span 1"
            backgroundColor={colors.primary[400]}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box display="flex" sx={{ justifyContent: "space-between" }}>
                <Typography
                  variant="h4"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  บ่อตะกอน
                </Typography>

                <Typography
                  variant="h4"
                  fontWeight="bold"
                  color={colors.greenAccent[300]}
                >
                  (ปกติ)
                </Typography>
              </Box>
            </Box>
            <Box height="180px" m="-20px 0 0 0">
              {dataPayloads.dataPayload3 ? (
                <LineChart3Param
                  isDashboard={true}
                  dataPayload={dataPayloads.dataPayload3}
                />
              ) : (
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color={colors.grey[100]}
                  textAlign="center"
                  mt="80px"
                >
                  Loading...
                </Typography>
              )}
            </Box>
          </Box>
          {/* Fourt pond */}
          <Box
            gridColumn="span 10"
            gridRow="span 1"
            backgroundColor={colors.primary[400]}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" sx={{ justifyContent: "space-between" }}>
                  <Typography
                    variant="h4"
                    fontWeight="600"
                    color={colors.grey[100]}
                  >
                    บ่อคลอรีน
                  </Typography>

                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color={colors.greenAccent[300]}
                  >
                    (ปกติ)
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box height="180px" m="-20px 0 0 0">
              {dataPayloads.dataPayload4 ? (
                <LineChart1Param
                  isDashboard={true}
                  dataPayload={dataPayloads.dataPayload4}
                />
              ) : (
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color={colors.grey[100]}
                  textAlign="center"
                  mt="80px"
                >
                  Loading...
                </Typography>
              )}
            </Box>
          </Box>
          {/* Fift pond */}
          <Box
            gridColumn="span 20"
            gridRow="span 1"
            backgroundColor={colors.primary[400]}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Box display="flex" sx={{ justifyContent: "space-between" }}>
                  <Typography
                    variant="h4"
                    fontWeight="600"
                    color={colors.grey[100]}
                  >
                    บ่อสูบน้ำเสีย
                  </Typography>

                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color={colors.greenAccent[300]}
                  >
                    (ปกติ)
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box height="180px" m="-20px 0 0 0">
              {dataPayloads.dataPayload2 ? (
                <LineChart2Param
                  isDashboard={true}
                  dataPayload={dataPayloads.dataPayload2}
                />
              ) : (
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color={colors.grey[100]}
                  textAlign="center"
                  mt="80px"
                >
                  Loading...
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
